import { Component, OnInit, ViewChild } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { NavService } from '../../_services/_nav.service';
import { TipoTerceroClasificacionService } from '../../_services/tipo-tercero-clasificacion.service';
import { Funcionalidad } from '../../_models/funcionalidad';
import { Router } from '@angular/router';
import { Table } from 'primeng/table';
import { AutenticacionService } from '../../_services/autenticacion.service';
import { AliadoService } from '../../_services/aliado.service';
import { Aliado } from '../../_models/aliado';
import { AliadoSucursalService } from '../../_services/aliado-sucursal.service';
import moment from 'moment';
import 'moment/locale/es';
import { AliadoUsuario } from '../../_models/aliado-usuario';
import { ConfirmationService } from 'primeng/api';
@Component( {
  selector: 'app-aliados-listado',
  templateUrl: 'aliados-listado.component.html'
} )

export class AliadosListadoComponent implements OnInit {

  aliados: Aliado[] = [];
  buscando = true;
  columnas: any = [];
  menu: Funcionalidad = new Funcionalidad();
  busqueda: string;
  @ViewChild('dt', { static: true }) tabla: Table;
  renovando = false;
  fechaActual: any;
  constructor( private fb: FormBuilder,
               private navServicio: NavService,
               private claTiposTercerosServicio: TipoTerceroClasificacionService,
               private router: Router,
               private autServicio: AutenticacionService,
               private aliadoSucursalService: AliadoSucursalService,
               private aliServicio: AliadoService,
               private conServicio: ConfirmationService) {
  }

  ngOnInit(): void {
    const fecha = moment().format('LL');
    const f = fecha.split(' ');
    this.fechaActual = f[2] + ', ' + f[4];

    const mn = this.autServicio.obtenerFuncionalidades().find( x => x.ruta === 'apl/aliados' );
    if ( mn ) {
      this.menu = mn;
    }
    this.busqueda = this.navServicio.getSearch( 'aliados.component' );
    this.aliServicio.listadoConCampos().subscribe( listado => {
      this.aliados = listado;
      this.tabla.filterGlobal( this.busqueda, 'contains' );
      this.buscando = false;
    } );


    this.columnas = [
      { field: 'numeroDocumento', header: this.navServicio.buscarMensaje( 'ALIADOS.LBL_DOCUMENTO' ), sort: false },
      { field: 'nombreCompleto', header: this.navServicio.buscarMensaje( 'ALIADOS.LBL_NOMBRE' ), sort: true },
      { field: 'ciudadesSucursales', header: this.navServicio.buscarMensaje( 'ALIADOS.LBL_MUNICIPIO' ), sort: true },
      { field: 'cantidadSucursales', header: this.navServicio.buscarMensaje( 'ALIADOS.LBL_SUCURSALES' ), sort: true },
      { field: 'cupoValor', header: this.navServicio.buscarMensaje( 'ALIADOS.LBL_CUPOVALOR' ), sort: true },
      { field: 'cupoCreditos', header: this.navServicio.buscarMensaje( 'ALIADOS.LBL_CUPOCREDITO' ), sort: true },
      { field: 'indicadorHabilitado', header: this.navServicio.buscarMensaje( 'ALIADOS.LBL_HABILITADO' ), sort: true },
      { field: 'det', header: this.navServicio.buscarMensaje( 'LBL_ACCIONES' ), sort: false }
    ];
  }

  crearAliado() {
    this.router.navigate( [ 'apl/aliados/seleccionar-tercero' ] );
  }

  renovarCupos() {
    this.renovando = true;
    this.aliadoSucursalService.renovarCupos().subscribe( res => {
      this.navServicio.setMesage( 0, { severity: 'success', summary: 'Exito', detail: 'La renovación de cupos para el mes en curso se realizo en forma correcta.' }  );
      this.renovando = false;
    }, error => {
      this.navServicio.setMesage( 0, { severity: 'error', summary: 'Error', detail: error.message } );
      this.renovando = false;
    } );

  }

  verAliado( aliado: Aliado ) {
    this.router.navigate( [ 'apl/aliados/detalle/' + aliado.idAliado ] );
  }

  editarAliado( aliado: Aliado ) {
    this.router.navigate( [ 'apl/aliados/sucursales/' + aliado.idAliado ] );
  }

  setBusqueda() {
    this.navServicio.setSearch( 'aliados.component', this.busqueda );
  }

  confirmar(){
    this.conServicio.confirm( {
      message: `¿Desea realizar la renovación de cupos aliados para ${this.fechaActual} ?`,
      header: this.navServicio.buscarMensaje( 'LBL_CONFIRMACION' ),
      icon: 'fa fa-question-circle',
      key: 'sucursal',
      accept: () => {
       this.renovarCupos();
      },
      reject: () => {
      }
    } );
  }
}
